var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-entity-content--container"},[_c('div',{staticClass:"faq-wrapper"},[_c('a',{staticClass:"btn btn-activate",staticStyle:{"max-width":"200px"},attrs:{"href":`mailto:${'support@enginio.io'}`}},[_vm._v(" CONTACT US ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }